"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pascalToFriendly = void 0;
var pascalToFriendly = function (pascalCasedString) {
    return pascalCasedString.replace(/([A-Z])/g, ' $1').trim();
};
exports.pascalToFriendly = pascalToFriendly;
//# sourceMappingURL=pascalToFriendly.js.map